import type { TimeRange } from '@carvia/ros-client-types';
import { sortBy } from 'lodash';

export type TimeRangesError = 'closingBeforeOpening' | 'overlap';

/** Same rules as the backend: each range ends after it starts and ranges must not overlap. */
export const findTimeRangesError = (ranges: TimeRange[]): TimeRangesError | undefined => {
  if (ranges.some((range) => range.end <= range.start)) return 'closingBeforeOpening';
  const sorted = sortBy(ranges, 'start');
  if (sorted.some((range, i) => i > 0 && range.start <= sorted[i - 1].end)) return 'overlap';
  return undefined;
};
